var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "url(#instagram-icon_svg__a)",
  rx: 17
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.003 8.639c2.725 0 3.045.012 4.122.06.997.045 1.535.211 1.896.353.477.186.818.405 1.174.761s.58.697.761 1.175c.138.36.308.899.353 1.895.048 1.077.06 1.397.06 4.122 0 2.726-.012 3.046-.06 4.123-.045.996-.21 1.535-.353 1.895a3.2 3.2 0 0 1-.761 1.175c-.356.356-.697.579-1.174.761-.36.138-.9.308-1.896.352-1.077.05-1.397.061-4.122.061-2.726 0-3.046-.012-4.123-.06-.996-.045-1.535-.211-1.895-.353a3.2 3.2 0 0 1-1.175-.761 3.1 3.1 0 0 1-.761-1.175c-.138-.36-.308-.899-.352-1.895-.049-1.077-.061-1.397-.061-4.123s.012-3.045.06-4.122c.045-.996.211-1.535.353-1.895.186-.478.405-.819.761-1.175.357-.356.697-.579 1.175-.761.36-.138.899-.308 1.895-.353 1.077-.052 1.401-.06 4.123-.06m0-1.839c-2.77 0-3.119.012-4.208.06-1.085.05-1.826.224-2.475.475-.672.259-1.239.611-1.806 1.178a5.1 5.1 0 0 0-1.178 1.806c-.251.648-.425 1.39-.474 2.479-.049 1.085-.06 1.433-.06 4.203s.011 3.119.06 4.208c.049 1.085.223 1.826.474 2.479.259.672.611 1.239 1.178 1.806a5.1 5.1 0 0 0 1.806 1.178c.649.251 1.39.425 2.479.474s1.434.06 4.208.06 3.118-.011 4.207-.06c1.086-.049 1.827-.223 2.479-.474a5 5 0 0 0 1.806-1.178 5.1 5.1 0 0 0 1.178-1.806c.252-.648.426-1.39.474-2.479.049-1.09.061-1.433.061-4.208 0-2.774-.012-3.118-.06-4.207-.05-1.086-.223-1.827-.475-2.479A5 5 0 0 0 25.5 8.51a5.1 5.1 0 0 0-1.806-1.178c-.648-.252-1.39-.426-2.479-.474-1.093-.045-1.441-.057-4.211-.057"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.003 11.765a5.241 5.241 0 1 0 .001 10.482 5.241 5.241 0 0 0-.001-10.482m0 8.638a3.401 3.401 0 1 1-.001-6.803 3.401 3.401 0 0 1 0 6.803M22.45 12.777a1.223 1.223 0 1 0 0-2.446 1.223 1.223 0 0 0 0 2.446"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "instagram-icon_svg__a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(0 -33.6965 31.3404 0 9.031 36.619)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#FD5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#FF543E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C837AB"
})))));
export default SvgInstagramIcon;